export default __webpack_public_path__ + "static/big-salesforce-abf9d8c174329f56342ac4466d95f95d.png";